import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableInventorySyncRefresh = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableInventorySyncRefresh);
};
